import LightLogo from '@/assets/images/light-logo.svg';
import { Button, Carousel, Checkbox } from '@/ui/components/base';
import { useSettings } from '@/store/settingsStore';
import Slide1Image from '@/assets/images/slide-1.png';
import Slide2Image from '@/assets/images/slide-2.png';
import Slide3Image from '@/assets/images/slide-3.png';
import Slide4Image from '@/assets/images/slide-4.png';
import Slide5Image from '@/assets/images/slide-5.png';
import './guide.css';

interface Slide {
    image: string;
    description: string;
}

const SLIDES: Slide[] = [
    {
        image: Slide1Image,
        description: 'Choose from 8 unique champions, each with different odds and racing style.',
    },
    {
        image: Slide2Image,
        description: 'Place your bet on any competitor before the race begins.',
    },
    {
        image: Slide3Image,
        description:
            'Random events can flip the standings at any moment — keep an eye on your position!',
    },
    {
        image: Slide4Image,
        description: 'Use the minimap to track your champion and anticipate upcoming twists.',
    },
    {
        image: Slide5Image,
        description: 'React with emojis and cheer your champion to victory!',
    },
];

interface GuideProps {
    startGame: () => void;
}

export const Guide = ({ startGame }: GuideProps) => {
    const setSkipLanding = useSettings((state) => state.setSkipLanding);
    const skipLanding = useSettings((state) => state.skipLanding);

    return (
        <div className="guide">
            <div className="guide__content">
                <header className="guide__logo">
                    <span>WELCOME TO</span>
                    <img src={LightLogo} alt="Goosicorn Racing Logo" />
                </header>

                <main className="guide__main">
                    <Carousel loop autoPlay>
                        {SLIDES.map((slide) => (
                            <div key={slide.description} className="guide__slide">
                                <div className="guide__slide-image-container">
                                    <img
                                        src={slide.image}
                                        alt={`Slide: ${slide.description}`}
                                        className="guide__slide-image"
                                    />
                                </div>
                                <p className="guide__slide-description">{slide.description}</p>
                            </div>
                        ))}
                    </Carousel>
                </main>

                <footer className="guide_actions">
                    <div className="guide__checkbox-container">
                        <Checkbox
                            checked={skipLanding}
                            onChange={setSkipLanding}
                            label="Don't show game features again"
                        />
                    </div>
                    <Button onClick={startGame}>Play game</Button>
                </footer>
            </div>
        </div>
    );
};
